module.exports = __webpack_public_path__ + "static/racism_spanish-4df126aa26ead4696a7686eb7de038ec.png";